import React from "react";
import { useTheme } from "@material-ui/styles";
import { Box, Hidden, useMediaQuery } from "@material-ui/core";

export const MOBILE_WIDTH = 465;

export default function AppWrapper(props) {
  const { background, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("xs"));
  let intViewportHeight = window.innerHeight;
  return (
    <>
      <Hidden xsDown={true}>
        <div id="background" style={background && { background: background }} />
      </Hidden>
      <Box
        height={"100%"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          style={{
            width: isMobile ? "100%" : MOBILE_WIDTH,
            height: isMobile || intViewportHeight < 800 ? "100%" : "85vh",
          }}
        >
          {props.children}
        </Box>
      </Box>
    </>
  );
}
